'use client';
/** @jsxImportSource @emotion/react */

import type { CardActionsProps as MuiCardActionsProps } from '@mui/material/CardActions';

import MuiCardActions from '@mui/material/CardActions';

type ExcludedMuiProps = 'disableTypography';
interface CardActionsProps extends Omit<MuiCardActionsProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { CardActionsProps };
export const CardActions = MuiCardActions;
